module.exports = __webpack_public_path__ + "static/media/readyToStart@3x.50df161a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/channel/readyToStart@3x.png
// module id = 1874
// module chunks = 6